var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37333 6.18326L9.98667 6.79659L3.94667 12.8366H3.33333V12.2233L9.37333 6.18326ZM11.7733 2.16992C11.6067 2.16992 11.4333 2.23659 11.3067 2.36326L10.0867 3.58326L12.5867 6.08326L13.8067 4.86326C14.0667 4.60326 14.0667 4.18326 13.8067 3.92326L12.2467 2.36326C12.1133 2.22992 11.9467 2.16992 11.7733 2.16992ZM9.37333 4.29659L2 11.6699V14.1699H4.5L11.8733 6.79659L9.37333 4.29659Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8912712c.svg";
export { ForwardRef as ReactComponent };